import { BRAND_NAME, waLink, WA_GENERAL_MESSAGE } from "../data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-bone/60 py-12 border-t border-white/10 text-xs">
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="font-display text-white text-base font-semibold">{BRAND_NAME}</span>
          <span aria-hidden="true">•</span>
          <span>Negozio Fisico &amp; Spedizioni in Tutta Italia</span>
        </div>
        <div className="flex gap-6">
          <a href="#vetrina" data-testid="footer-link-capi" className="hover:text-white transition-colors">
            Capi
          </a>
          <a href="#come-funziona" data-testid="footer-link-spedizioni" className="hover:text-white transition-colors">
            Spedizioni
          </a>
          <a href="#dove-trovarci" data-testid="footer-link-dove-trovarci" className="hover:text-white transition-colors">
            Negozio
          </a>
          <a
            href={waLink(WA_GENERAL_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-link-whatsapp"
            className="hover:text-white transition-colors"
          >
            WhatsApp
          </a>
        </div>
      </div>
    </footer>
  );
};
